import { render, staticRenderFns } from "./LookupPostcode.vue?vue&type=template&id=d8f76d40&scoped=true"
import script from "./LookupPostcode.vue?vue&type=script&lang=ts"
export * from "./LookupPostcode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f76d40",
  null
  
)

export default component.exports